import React, {useCallback, useState, ReactElement} from 'react';
import {Link} from 'react-router-dom';

import OfelosPayLogotypeSvg from 'svg/landing-logotype/ofelos-pay-logotype.svg';
import OpenMenuSvg from 'svg/buttons/open-menu-icon.svg';
import CloseMenuSvg from 'svg/buttons/close-menu-icon.svg';
import {Link as LinkScroll} from 'react-scroll';

const Links = (props: { onClick: () => void }): ReactElement => location.pathname === '/'
    ? <> <LinkScroll
        smooth
        duration={600}
        to="business"
        className="ofelos-pay-menu__item"
        onClick={props.onClick}
    >
            Business
    </LinkScroll>
    <LinkScroll
        smooth
        duration={600}
        to="payment-solutions"
        className="ofelos-pay-menu__item"
        onClick={props.onClick}
    >
                Payment solutions
    </LinkScroll>
    <LinkScroll
        smooth
        duration={700}
        to="contact"
        className="ofelos-pay-menu__item"
        onClick={props.onClick}
    >
                Contact
    </LinkScroll></>
    : <>
        <Link
            className="ofelos-pay-menu__item"
            to="/?anchor=business"
            onClick={props.onClick}
        >Business</Link>
        <Link
            className="ofelos-pay-menu__item"
            to="/?anchor=payment-solutions"
            onClick={props.onClick}
        >Payment solutions</Link>
        <Link
            className="ofelos-pay-menu__item"
            to="/?anchor=contact"
            onClick={props.onClick}
        >Contact</Link>
    </>;

const Header = (): ReactElement => {
    const [active, setActive] = useState(false);

    const OpenMenu = useCallback(() => {
        setActive(!active);
        if (active) {
            document.body.classList.remove('stop-scroll');
        } else {
            document.body.classList.add('stop-scroll');
        }
    }, [active]);

    return <header className="ofelos-pay-header">
        <div className="ofelos-pay-inner">
            <div className="ofelos-pay-logotype">
                <Link to="/">
                    <img src={OfelosPayLogotypeSvg} alt="Ofelos Pay Logotype"/>
                </Link>
            </div>
            <nav className={`ofelos-pay-menu ${active ? 'active' : ''}`}>
                {<Links onClick={OpenMenu}/>}
            </nav>
            <div className="ofelos-pay-menu-mobile">
                <button className={`button-open-menu ${active ? 'active' : ''}`} onClick={OpenMenu}>
                    <img className="open-svg" src={OpenMenuSvg}/>
                    <img className="close-svg" src={CloseMenuSvg}/>
                </button>
            </div>
        </div>
    </header>;
};

export default Header;
